
const Header = () => {
    return (
        <header className="bg-gray-500 text-black text-center z-10 p-5 shadow-sm">
            <h2>header</h2>
        </header>
    )
}

export default Header;